import './index.scss'
import {PageSubTitle, PageTitle, ResponsivePageTitle} from '../../components/core/title'
import {SimpleBlueButton} from '../../components/core/button'
import Input from '../../components/core/input'
import Footer from '../../components/layouts/footer'
import {Formik} from 'formik'
import {customerSchema} from '../../utils/validation'
import localStorageManager from '../../utils/localStorageManager'
import {handleFormChanges} from '../../utils/forms'
import {useDispatch, useSelector} from 'react-redux'
import {useState} from 'react'
import {setButtonIsDisabled, updateCustomer} from '../../stores/customer-settings'
import ButtonLoader from '../../components/core/button/ButtonLoader'
import classNames from 'classnames'
import {trimStringValues} from '../../utils/text'
import {useNamespaceTranslations} from '../../utils/hooks/useNamespacesTranslations'

const CustomerSettings = () => {
    const text = useNamespaceTranslations('customer-settings')
    const buttonIsDisabled = useSelector(state => state.customer_settings.buttonIsDisabled)
    const showLoader = useSelector(state => state.customer_settings.showLoader)
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const dispatch = useDispatch()
    const [active, setActive] = useState(null)
    const names = {
        name: 'name',
        surname: 'surname'
    }
    const customer = localStorageManager.get('customer')
    const initialFormValues = {
        name: customer?.name,
        surname: customer?.surname
    }
    const updateCustomerData = (values, {setFieldError}) => {
        dispatch(updateCustomer(trimStringValues(values), setFieldError))
        dispatch(setButtonIsDisabled(true))
    }

    const handleInfo = (index, state) => {
        state ? setActive(index) : setActive(null)
    }

    return (
        <main className={classNames('main settings', {
            dark: isDarkMode
        })}>
            <div>
                <ResponsivePageTitle/>
                <div className="content-title">
                    <div className="left-side">
                        <div>
                            <PageSubTitle>
                                <p className={classNames('section', {
                                    dark: isDarkMode
                                })}>{text.section}</p>
                            </PageSubTitle>
                            <PageTitle>
                                <h1  className={classNames('page-title', {
                                    dark: isDarkMode
                                })}>{text.title}</h1>
                            </PageTitle>
                        </div>
                    </div>
                </div>
                <div className="content-body">
                    <Formik
                        initialValues={initialFormValues}
                        onSubmit={updateCustomerData}
                        validationSchema={customerSchema}
                        validateOnBlur={false}
                        validateOnChange={false}>
                        {({values, errors, setFieldValue, handleSubmit}) => (
                            <form onSubmit={handleSubmit} className="form-elements">
                                <Input
                                    value={values.name}
                                    placeholder={text.name}
                                    infoText={text.name_info}
                                    name={names.name}
                                    onChange={e => dispatch(setButtonIsDisabled(handleFormChanges(e, 'name', setFieldValue, initialFormValues)))}
                                    error={errors.name}
                                    activeInfo={active === names.name}
                                    handleInfo={(state) => handleInfo(names.name, state)}
                                />
                                <Input
                                    value={values.surname}
                                    placeholder={text.surname}
                                    infoText={text.surname_info}
                                    name={names.surname}
                                    onChange={e => dispatch(setButtonIsDisabled(handleFormChanges(e, 'surname', setFieldValue, initialFormValues)))}
                                    error={errors.surname}
                                    activeInfo={active === names.surname}
                                    handleInfo={(state) => handleInfo(names.surname, state)}
                                />
                                <SimpleBlueButton disabled={buttonIsDisabled}
                                    type="submit">
                                    {showLoader && <ButtonLoader/>}
                                    {text.save_changes}
                                </SimpleBlueButton>
                            </form>
                        )}
                    </Formik>
                </div>
            </div>
            <Footer/>
        </main>
    )
}

export default CustomerSettings
